
import menu1 from "../img/menu-1.webp";
import menu2 from "../img/menu-2.png";
import menu3 from "../img/menu-3.webp";
import menu4 from "../img/menu-4.webp";
import menu5 from "../img/menu-5.webp";
import menu6 from "../img/menu-6.webp";
import menu7 from "../img/menu-7.png";
import menu8 from "../img/menu-8.webp";


const menuData = {
    "About Us": {
        Key: 1,
        eyebrow: "Discover ISBMU",
        title: "A university built around possibility.",
        description:
            "Meet the people, purpose and principles shaping an ambitious academic community.",
        groups: [
            {
                title: "About ISBM University",
                links: [
                    { title: "About ISBM University", url: "/about-us" },
                    { title: "Vision & Mission", url: "/vision-mission" },
                    {
                        title: "Leadership & Management",
                        url: "/leadership-and-management",
                    },
                    {
                        title: "University Administration",
                        url: "/university-administration",
                    },
                    { title: "Board of Advisors", url: "/board-advisor" },
                    {
                        title: "Messages of the Dignitaries",
                        url: "/dignitaries-messages",
                    },
                ],
            },
            {
                title: "Governance & Recognition",
                links: [
                    { title: "Statutes & Ordinances", url: "/statues-and-ordinance" },
                    {
                        title: "Accreditations & Recognitions",
                        url: "/accreditation-and-recognitions",
                    },
                    { title: "Awards", url: "/awards" },
                    { title: "Media Coverage", url: "/media-coverage" },
                    { title: "Code of Conduct", url: "/code-of-conduct-and-rti" },
                    { title: "Raj Bhavan", url: "https://rajbhavancg.gov.in/" },
                ],
            },
        ],
        image: menu1,
    },

    Academics: {
        eyebrow: "Learn with purpose",
        title: "Where rigorous thinking meets real-world impact.",
        description:
            "Explore an interdisciplinary academic ecosystem designed for tomorrow's challenges.",

        groups: [
            {
                title: "Academic Excellence",
                links: [
                    {
                        title: "Academic Philosophy",
                        url: "/academic-philosophy",
                    },
                    {
                        title: "Academic Partners",
                        url: "/academic-partner",
                    },
                    {
                        title: "Online Resources",
                        url: "/online-resources",
                    },
                    {
                        title: "Teaching Methodology / Pedagogy",
                        url: "/teaching-methodology-pedagogy",
                    },
                ],
            },
            {
                title: "Learning & Collaboration",
                links: [
                    {
                        title: "MOOC's with ISBM University",
                        url: "/mooc-with-isbm",
                    },
                    {
                        title: "MOU's and Collaborations",
                        url: "/mous-and-collaborations",
                    },
                    {
                        title: "Academic Calendar",
                        url: "/academic-calender",
                    },
                    {
                        title: "Blogs",
                        url: "/blog",
                    },
                ],
            },
        ],

        image: menu2,
    },

    Programmes: {
        eyebrow: "Find your programme",
        title: "Choose a path that moves you forward.",
        description:
            "Explore programmes offered across all academic schools and discover the right career path for your future.",
        groups: [
            {
                title: "Professional & Technology Schools",
                links: [
                    {
                        title: "School of Management",
                        url: "/school/management",
                        courses: [
                            { title: "Doctor of Philosophy (Ph.D.) in Management", url: "/course/doctor-of-philosophy-in-management" },
                            { title: "Master Of Business Administration (MBA)", url: "/course/master-of-business-administration" },
                            { title: "Executive Master of Business Administration (EMBA)", url: "/course/executive-master-of-business-administration" },
                            { title: "Bachelor of Business Administration (BBA)", url: "/course/bachelor-of-business-administration" },
                            { title: "Post Graduate Diploma in Business Administration (PGDBA)", url: "/course/post-graduate-diploma-in-business-administration" },
                            { title: "Diploma in Business Administration (DBA)", url: "/course/diploma-in-business-administration" },
                            { title: "Post Graduate Diploma In Business Management (PGDBM)", url: "/course/post-graduate-diploma-in-business-management-pgdbm" },
                            { title: "Postgraduate Diploma In Management (PGDM)", url: "/course/postgraduate-diploma-in-management-pgdm" },
                        ],
                    },
                    {
                        title: "School of Commerce",
                        url: "/school/commerce",
                        courses: [
                            { title: "Doctor of Philosophy (Ph.D.) in Commerce", url: "/course/doctor-of-philosophy-in-commerce" },
                            { title: "Master of Commerce (M.Com)", url: "/course/master-of-commerce" },
                            { title: "B.Com in Computer Application", url: "/course/bcom-in-computer-application" },
                            { title: "Bachelor of Commerce (Hons)", url: "/course/bachelor-of-commerce-honours" },
                            { title: "Bachelor Of Commerce (B.com)", url: "/course/bachelor-of-commerce" },
                            { title: "Post Graduate Diploma in Commerce (PGDCOM)", url: "/course/post-graduate-diploma-in-commerce" },
                            { title: "Diploma in Commerce", url: "/course/diploma-in-commerce" },
                        ]
                    },
                    {
                        title: "School of Engineering & Technology",
                        url: "/school/engineering-and-technology",
                        courses: [
                            { title: "Doctor of Philosophy (Ph.D.) in Engineering and Technology", url: "/course/doctor-of-philosophy-in-engineering-and-technology" },
                            { title: "Master of Technology (M.Tech)", url: "/course/master-of-technology" },
                            { title: "Bachelor of Technology (B.Tech)", url: "/course/bachelor-of-technology" },
                            { title: "Bachelor of Technology (B.Tech) (Lateral Entry)", url: "/course/bachelor-of-technology-lateral" },
                            { title: "Diploma in Engineering", url: "/course/diploma-in-engineering" },
                            { title: "Diploma in Engineering (Lateral Entry)", url: "/course/diploma-in-engineering-lateral" },
                            { title: "M.tech In Computer Science", url: "/course/mtech-in-computer-science" },
                            { title: "M.Tech in Structural", url: "/course/mtech-in-structural" },
                            { title: "M.Tech in Construction Technology & Management", url: "/course/mtech-in-construction-technology-and-management" },
                            { title: "M.Tech in Geo Technical Engineering", url: "/course/mtech-in-geo-technical-engineering" },
                            { title: "M.Tech in Highway Engineering", url: "/course/mtech-in-highway-engineering" },
                            { title: "M.Tech in Production", url: "/course/mtech-in-production" },
                            { title: "M.Tech in Energy Management", url: "/course/mtech-in-energy-management" },
                            { title: "M.Tech in Thermal", url: "/course/mtech-in-thermal" },
                            { title: "M.Tech in Safety", url: "/course/mtech-in-safety" },
                            { title: "Diploma in Civil Engineering", url: "/course/diploma-in-civil-engineering" },
                            { title: "Diploma in Mechanical Engineering", url: "/course/diploma-in-mechanical-engineering" },
                            { title: "Diploma in Electrical & Electronics Engineering", url: "/course/diploma-in-electronics-and-electrical-engineering" },
                            { title: "Diploma in Computer Science", url: "/course/diploma-in-computer-science" },
                            { title: "Diploma in Mining Engineering", url: "/course/diploma-in-mining-engineering" },
                            { title: "Diploma in Chemical Engineering", url: "/course/diploma-in-chemical-engineering" },
                            { title: "Bachelor Of Technology (B.tech) In Artificial Intelligence & Machine Learning", url: "/course/bachelor-of-technology-btech-in-artificial-intelligence-machine-learning" },
                            { title: "Bachelor Of Technology (B.tech) In Cyber Security & Blockchain", url: "/course/bachelor-of-technology-btech-in-cyber-security-blockchain" },
                            { title: "Bachelor Of Technology (B.tech) In Data Science & Data Engineering", url: "/course/bachelor-of-technology-btech-in-data-science-data-engineering" },
                            { title: "Bachelor Of Technology (B.tech) In Ai & Data Analytics", url: "/course/bachelor-of-technology-btech-in-ai-data-analytics" },
                            { title: "Master Of Technology (M.tech) In Artificial Intelligence & Machine Learning", url: "/course/master-of-technology-mtech-in-artificial-intelligence-machine-learning" },
                            { title: "Master Of Technology (M.tech) In Cyber Security & Blockchain", url: "/course/master-of-technology-mtech-in-cyber-security-blockchain" },
                            { title: "Master Of Technology (M.tech) In Data Science & Data Engineering", url: "/course/master-of-technology-mtech-in-data-science-data-engineering" },
                            { title: "Master Of Technology (M.tech) In Artificial Intelligence & Data Analytics", url: "/course/master-of-technology-mtech-in-artificial-intelligence-data-analytics" },
                        ]
                    },
                    {
                        title: "School of Information & Technology",
                        url: "/school/information-and-technology",
                        courses: [
                            { title: "Doctor of Philosophy (Ph.D.) in Information Technology", url: "/course/doctor-of-philosophy-in-information-technology" },
                            { title: "M.sc. In Information Technology (M.sc It)", url: "/course/msc-in-information-technology" },
                            { title: "M.Sc. in Computer Science (M.Sc. CS)", url: "/course/msc-in-computer-science" },
                            { title: "Master of Computer Applications (MCA)", url: "/course/master-of-computer-applications" },
                            { title: "M.Sc. in Data Science", url: "/course/msc-in-data-science" },
                            { title: "B.Sc. (Hons) in Information Technology", url: "/course/bsc-in-information-technology" },
                            { title: "B.Sc. (Hons) in Computer Science", url: "/course/bsc-in-computer-science" },
                            { title: "Bachelor Of Computer Applications (Bca)", url: "/course/bachelor-of-computer-applications" },
                            { title: "B.Sc. in Data Science", url: "/course/bsc-in-data-science" },
                            { title: "Post Graduate Diploma in Computer Application (PGDCA)", url: "/course/post-graduate-diploma-in-computer-application" },
                            { title: "Post Graduate Diploma in Data Science", url: "/course/post-graduate-diploma-in-data-science" },
                            { title: "Post Graduate Diploma in AI & ML", url: "/course/post-graduate-diploma-in-ai-and-ml" },
                            { title: "Diploma in Computer Application (DCA)", url: "/course/diploma-in-computer-application" },
                            { title: "Diploma in AI & ML", url: "/course/diploma-in-ai-and-ml" },
                            { title: "Advance Diploma In Computer Applications (ADCA)", url: "/course/advance-diploma-in-computer-applications-adca" },
                            { title: "Bachelor Of Science (B.sc) In Devops & Full Stack Development", url: "/course/bachelor-of-science-bsc-in-devops-full-stack-development" },
                            { title: "Bachelor Of Science (B.sc) In Internet Of Things (Iot)", url: "/course/bachelor-of-science-bsc-in-internet-of-things-iot" },
                            { title: "Bachelor Of Science (B.sc) In Cloud Computing", url: "/course/bachelor-of-science-bsc-in-cloud-computing" },
                            { title: "Bachelor Of Science (B.sc) In Full Stack Development", url: "/course/bachelor-of-science-bsc-in-full-stack-development" },
                            { title: "Bachelor Of Science (B.sc) In Computer Science & Business Intelligence", url: "/course/bachelor-of-science-bsc-in-computer-science-business-intelligence" },
                            { title: "Bachelor Of Science (B.sc) In Artificial Intelligence & Machine Learning", url: "/course/bachelor-of-science-bsc-in-artificial-intelligence-machine-learning" },
                        ]
                    },
                    {
                        title: "School of Science",
                        url: "/school/science",
                        courses: [
                            { title: "Doctor of Philosophy (Ph.D.) in Science", url: "/course/doctor-of-philosophy-in-science" },
                            { title: "Master Of Science (M.sc.)", url: "/course/master-of-science" },
                            { title: "M.Sc. in Stem Cells and Tissue Culture Engineering (M.Sc. SCTCE)", url: "/course/msc-in-stem-cells-and-tissue-culture-engineering" },
                            { title: "M.Sc. in Fire & Safety (M.Sc. F&S)", url: "/course/msc-in-fire-and-safety" },
                            { title: "M.Sc. in Forensic Science & Criminology (M.Sc. FSC)", url: "/course/msc-in-forensic-science-and-criminology" },
                            { title: "Bachelor of Science (Hons)", url: "/course/bachelor-of-science-honours" },
                            { title: "Bachelor of Science (BSc)", url: "/course/bachelor-of-science" },
                            { title: "B.Sc. in Forensic Science & Criminology (B.Sc. FSC)", url: "/course/bsc-in-forensic-science-and-criminology" },
                            { title: "B.Sc. in Fire & Safety", url: "/course/bsc-in-fire-and-safety" },
                            { title: "Post Graduate Diploma in Science (PGDSC)", url: "/course/post-graduate-diploma-in-science" },
                            { title: "Diploma in Nutrition (DIN)", url: "/course/diploma-in-nutrition" },
                            { title: "Diploma in Science", url: "/course/diploma-in-science" },
                            { title: "Diploma in Forensic Science & Criminology", url: "/course/diploma-in-forensic-science-and-criminology" },
                        ]
                    },
                    {
                        title: "School of Arts & Humanities",
                        url: "/school/arts-and-humanities",
                        courses: [
                            { title: "Doctor of Philosophy (Ph.D.) in Arts and Humanities", url: "/course/doctor-of-philosophy-in-arts-and-humanities" },
                            { title: "Master of Arts (M.A)", url: "/course/master-of-arts" },
                            { title: "Master of Social Work (MSW)", url: "/course/master-of-social-work" },
                            { title: "Bachelor of Arts (Hons)", url: "/course/bachelor-of-arts-honours" },
                            { title: "Bachelor Of Arts (B.a)", url: "/course/bachelor-of-arts" },
                            { title: "Bachelor of Social Work (BSW)", url: "/course/bachelor-of-social-work" },
                            { title: "Post Graduate Diploma in Rural Development", url: "/course/post-graduate-diploma-in-rural-development" },
                            { title: "Masters of Arts in English", url: "/course/masters-of-arts-in-english" },
                            { title: "Master of Arts in Hindi", url: "/course/master-of-arts-in-hindi" },
                            { title: "Master of Arts in Chhattisgarhi", url: "/course/master-of-arts-in-chhattisgarhi" },
                            { title: "Master of Arts in Philosophy", url: "/course/master-of-arts-in-philosophy" },
                            { title: "Master of Arts in History and Archaeology", url: "/course/master-of-arts-in-history-and-archaeology" },
                            { title: "Master of Arts in Politic Science", url: "/course/master-of-arts-in-politic-science" },
                            { title: "Master of Arts in Public Administration", url: "/course/master-of-arts-in-public-administration" },
                            { title: "Master of Arts in Economics", url: "/course/master-of-arts-in-economics" },
                            { title: "Master of Arts in Education", url: "/course/master-of-arts-in-education" },
                            { title: "Master of Arts in Sociology", url: "/course/master-of-arts-in-sociology" },
                            { title: "Master of Arts in Geography", url: "/course/master-of-arts-in-geography" },
                            { title: "Master of Arts in Psycology", url: "/course/master-of-arts-in-psycology" },
                            { title: "Master of Arts in Sanskrit", url: "/course/master-of-arts-in-sanskrit" },
                            { title: "Master of Arts in Disaster Management", url: "/course/master-of-arts-in-disaster-management" },
                            { title: "Master of Arts in Public Health", url: "/course/master-of-arts-in-public-health" },
                            { title: "Ba (Honours) Disaster Management", url: "/course/ba-honours-disaster-management" },
                            { title: "Ma Disaster Management", url: "/course/ma-disaster-management" },
                            { title: "Ma (Physical Education & Sports)", url: "/course/ma-physical-education-sports" },
                        ]
                    },
                    {
                        title: "School of Law",
                        url: "/school/law",
                        courses: [
                            { title: "Doctor Of Philosophy (Ph.d.) In Law", url: "/course/doctor-of-philosophy-in-law" },
                            { title: "Master of Law (LLM)", url: "/course/master-of-law" },
                            { title: "Bachelor Of Law (Llb)", url: "/course/bachelor-of-law" },
                            { title: "Bachelor of Business Administration and Bachelor of Law (BBA LLB)", url: "/course/bachelor-of-business-administration-and-bachelor-of-law" },
                            { title: "Bachelor of Arts and Bachelor of Law (BA LLB)", url: "/course/bachelor-of-arts-and-bachelor-of-law" },
                            { title: "Post Graduate Diploma in Law", url: "/course/post-graduate-diploma-in-law" },
                            { title: "Diploma in Law", url: "/course/diploma-in-law" },
                        ]
                    },
                    {
                        title: "School of Pharmacy",
                        url: "/school/pharmacy",
                        courses: [
                            { title: "Doctor of Philosophy (Ph.D.) in Pharmacy", url: "/course/doctor-of-philosophy-in-pharmacy" },
                            { title: "Master of Pharmacy (M Pharma)", url: "/course/master-of-pharmacy" },
                            { title: "Bachelor of Pharmacy (B Pharma)", url: "/course/bachelor-of-pharmacy" },
                            { title: "Diploma in Pharmacy (D Pharma)", url: "/course/diploma-in-pharmacy" },
                        ]
                    },
                    {
                        title: "School of Design",
                        url: "/school/design",
                        courses: [
                            { title: "B.Sc. (Hons) in Fashion Designing", url: "/course/bsc-in-fashion-designing" },
                            { title: "B.Sc. (Hons) in Interior Design", url: "/course/bsc-in-interior-design" },
                            { title: "Diploma in Fashion Designing (DFD)", url: "/course/diploma-in-fashion-designing" },
                            { title: "Diploma in Interior Design (DID)", url: "/course/diploma-in-interior-design" },
                            { title: "Diploma in Product Design", url: "/course/diploma-in-product-design" },
                            { title: "Diploma in Jewellery Design", url: "/course/diploma-in-jewellery-design" },
                            { title: "Certificate in Fashion Designing (CFD)", url: "/course/certificate-in-fashion-designing" },
                            { title: "Certificate in Interior Design (CID)", url: "/course/certificate-in-interior-design" },
                            { title: "Msc In Interior Design", url: "/course/msc-in-interior-design" },
                            { title: "Msc In Fashion Design", url: "/course/msc-in-fashion-design" },
                        ]
                    },
                ],
            },
            {
                title: "Specialized & Emerging Schools",
                links: [
                    {
                        title: "School of Education",
                        url: "/school/education",
                        courses: [
                            { title: "Doctor of Philosophy (Ph.D.) in Education", url: "/course/doctor-of-philosophy-in-education" },
                            { title: "Master of Arts in Education", url: "/course/master-of-arts-in-education" },
                            { title: "Bachelor of Arts (Hons) in Education", url: "/course/bachelor-of-arts-hons-in-education" },
                        ]
                    },
                    {
                        title: "School of Journalism & Mass Communication",
                        url: "/school/journalism-and-mass-communication",
                        courses: [
                            { title: "Doctor of Philosophy (Ph.D.) in Journalism and Mass Communication", url: "/course/doctor-of-philosophy-in-journalism-and-mass-communication" },
                            { title: "Master of Arts in Journalism and Mass Communication (MA JMC)", url: "/course/master-of-arts-in-journalism-and-mass-communication" },
                            { title: "Bachelor of Arts (Hons) in Journalism and Mass Communication (BA JMC)", url: "/course/bachelor-of-arts-hons-in-journalism-and-mass-communication" },
                            { title: "Diploma in Journalism and Mass Communication (D JMC)", url: "/course/diploma-in-journalism-and-mass-communication" },
                        ]
                    },
                    {
                        title: "School of Hotel Management",
                        url: "/school/hotel-management",
                        courses: [
                            { title: "Doctor of Philosophy (Ph.D.) in Hotel Management and Catering Technology", url: "/course/doctor-of-philosophy-in-hotel-management-and-catering-technology" },
                            { title: "Master of Hotel Management and Catering Technology", url: "/course/master-of-hotel-management-and-catering-technology" },
                            { title: "Bachelor of Hotel Management and Catering Technology (BHMCT)", url: "/course/bachelor-of-hotel-management-and-catering-technology" },
                            { title: "Diploma in Hotel Management and Catering Technology (DHMCT)", url: "/course/diploma-in-hotel-management-and-catering-technology" },
                            { title: "Diploma in Culinary Arts", url: "/course/diploma-in-culinary-arts" },
                            { title: "Diploma in Travel & Tourism", url: "/course/diploma-in-travel-and-tourism" },
                            { title: "B.Sc. (Hotel Management)", url: "/course/bsc-hotel-management" },
                            { title: "M.Sc. (Hotel Management)", url: "/course/msc-hotel-management" },
                        ]
                    },
                    {
                        title: "School of Media & Entertainment",
                        url: "/school/media-and-entertainment",
                        courses: [
                            { title: "Doctor of Philosophy (Ph.D.) in Media and Entertainment", url: "/course/doctor-of-philosophy-in-media-and-entertainment" },
                            { title: "M.A. in Film Making and Advertising", url: "/course/ma-in-film-making-and-advertising" },
                            { title: "M.A. in Public Relation and Event Management", url: "/course/ma-in-public-relation-and-event-management" },
                            { title: "B.A. (Hons) in Film Making and Advertising", url: "/course/ba-hons-in-film-making-and-advertising" },
                            { title: "B.A. (Hons) in Public Relation and Event Management", url: "/course/ba-hons-in-public-relation-and-event-management" },
                            { title: "Diploma in Photography", url: "/course/diploma-in-photography" },
                            { title: "Diploma in Script Writing", url: "/course/diploma-in-script-writing" },
                            { title: "Diploma in Advertising", url: "/course/diploma-in-advertising" },
                            { title: "Diploma in Branding", url: "/course/diploma-in-branding" },
                            { title: "Diploma in VFX and Animation", url: "/course/diploma-in-vfx-and-animation" },
                        ]
                    },
                    {
                        title: "School of Library & Information Science",
                        url: "/school/library-and-information-science",
                        courses: [
                            { title: "Doctor of Philosophy (Ph.D.) in Library and Information Science", url: "/course/doctor-of-philosophy-in-library-and-information-science" },
                            { title: "Master of Library and Information Science (M.Lib. & I.Sc.)", url: "/course/master-of-library-and-information-science" },
                            { title: "Bachelor of Library and Information Science (B.Lib. & I.Sc.)", url: "/course/bachelor-of-library-and-information-science" },
                        ]
                    },
                    {
                        title: "School of Yoga & Naturopathy",
                        url: "/school/yoga-and-naturopathy",
                        courses: [
                            { title: "Doctor of Philosophy (Ph.D.) in Yoga Science and Naturopathy", url: "/course/doctor-of-philosophy-in-yoga-science-and-naturopathy" },
                            { title: "M.Sc. in Yoga Science and Naturopathy", url: "/course/msc-in-yoga-science-and-naturopathy" },
                            { title: "M.A. in Yoga", url: "/course/ma-in-yoga" },
                            { title: "B.Sc. (Hons) in Yoga Science and Naturopathy", url: "/course/bsc-hons-in-yoga-science-and-naturopathy" },
                            { title: "B.A. (Hons) in Yoga", url: "/course/ba-hons-in-yoga" },
                            { title: "Post Graduate Diploma in Yoga and Naturopathy", url: "/course/post-graduate-diploma-in-yoga-and-naturopathy" },
                            { title: "Diploma in Yoga (DIY)", url: "/course/diploma-in-yoga" },
                            { title: "Diploma in Naturopathy (DN)", url: "/course/diploma-in-naturopathy" },
                        ]
                    },
                    {
                        title: "School of Life Science",
                        url: "/school/life-science",
                        courses: [
                            { title: "Doctor of Philosophy (Ph.D.) in Life Science", url: "/course/doctor-of-philosophy-in-life-science" },
                            { title: "M.Sc. in Bio Technology", url: "/course/msc-in-biotechnology" },
                            { title: "M.Sc. in Microbiology", url: "/course/msc-in-microbiology" },
                            { title: "B.Sc. (Hons) in Bio Technology", url: "/course/bsc-hons-in-biotechnology" },
                            { title: "B.Sc. (Hons) in Microbiology", url: "/course/bsc-hons-in-microbiology" },
                        ]
                    },
                    {
                        title: "School of Vocational Management",
                        url: "/school/vocational-management",
                        courses: [
                            { title: "Bachelor of Vocational Management", url: "/course/bachelor-of-vocational-management" },
                            { title: "Diploma in Vocational Management", url: "/course/diploma-in-vocational-management" },
                            { title: "Certificate in Vocational Management", url: "/course/certificate-in-vocational-management" },
                            { title: "B.Voc in Software & Web Development", url: "/course/bvoc-software-web-development" },
                            { title: "B.Voc in Networking & System Maintenance", url: "/course/bvoc-networking-system-maintenance" },
                            { title: "B.Voc in Cloud Computing", url: "/course/bvoc-cloud-computing" },
                            { title: "B.Voc in Programming with Python", url: "/course/bvoc-programming-with-python" },
                            { title: "B.Voc in Graphic & Multimedia", url: "/course/bvoc-graphic-multimedia" },
                            { title: "B.Voc in Digital Marketing", url: "/course/bvoc-digital-marketing" },
                            { title: "B.Voc in Fashion Designing", url: "/course/bvoc-fashion-designing" },
                            { title: "B.Voc in Interior Designing", url: "/course/bvoc-interior-designing" },
                            { title: "B.Voc in Jewellery Designing", url: "/course/bvoc-jewellery-designing" },
                            { title: "B.Voc in Music", url: "/course/bvoc-music" },
                            { title: "B.Voc in Sports Management", url: "/course/bvoc-sports-management" },
                            { title: "B.Voc in Event Management", url: "/course/bvoc-event-management" },
                            { title: "B.Voc in Food Processing Engineering", url: "/course/bvoc-food-processing-engineering" },
                            { title: "B.Voc in Pharmaceutical Manufacturing", url: "/course/bvoc-pharmaceutical-manufacturing" },
                            { title: "B.Voc in Electronic Manufacturing", url: "/course/bvoc-electronic-manufacturing" },
                            { title: "B.Voc in Cyber Law", url: "/course/bvoc-cyber-law" },
                            { title: "B.Voc in Tally & GST", url: "/course/bvoc-tally-gst" },
                        ]
                    },
                    {
                        title: "School of Health & Allied Science",
                        url: "/school/health-and-allied-science",
                        courses: [
                            { title: "M.Sc. in Medical Biotechnology (M.Sc. MBT)", url: "/course/msc-in-medical-biotechnology" },
                            { title: "Bachelor of Physiotherapy", url: "/course/bachelor-of-physiotherapy" },
                            { title: "B.Sc. (Hons) in Forensic Science", url: "/course/bsc-hons-in-forensic-science" },
                            { title: "B.Sc. (Hons) in Nutrition & Dietetics", url: "/course/bsc-hons-in-nutrition-and-dietetics" },
                            { title: "B.A. (Hons) in Public Health", url: "/course/ba-hons-in-public-health" },
                            { title: "Post Graduate Diploma in Nutrition and Dietetics", url: "/course/post-graduate-diploma-in-nutrition-and-dietetics" },
                            { title: "Diploma in Dietetics", url: "/course/diploma-in-dietetics" },
                            { title: "Diploma in Nutrition", url: "/course/diploma-in-nutrition" },
                        ]
                    },
                ],
            },
        ],
        image: menu3,
    },

    Admissions: {
        eyebrow: "Start your journey",
        title: "Your future begins with one bold step.",
        description:
            "Join ISBM University through a simple admission process and take the first step towards a successful career.",
        groups: [
            {
                title: "Apply & Eligibility",
                links: [
                    {
                        title: "Programmes and Eligibilities",
                        url: "/programmes-and-eligibilities",
                    },
                    {
                        title: "Programmes By Qualification",
                        url: "/programmes-by-qualification",
                    },
                    {
                        title: "Skill Development",
                        url: "/skill-development",
                    },
                    {
                        title: "Research",
                        url: "/research",
                    },
                    {
                        title: "Apply Online",
                        url: "/apply-online",
                    },
                ],
            },
            {
                title: "Payments & Assistance",
                links: [
                    {
                        title: "Online Payment",
                        url: "/pay-fees-online",
                    },
                    {
                        title: "Payment Procedure Guidelines",
                        url: "/payment-procedure-guidelines",
                    },
                    {
                        title: "Admission Procedure Guidelines",
                        url: "/admission-procedure-guidelines",
                    },
                    {
                        title: "Admission Helpdesk",
                        url: "/admission-help-desk",
                    },
                ],
            },
        ],
        image: menu4,
    },

    "Student Services": {
        eyebrow: "Here for every student",
        title: "Support that goes beyond the classroom.",
        description:
            "Resources, wellbeing and opportunities designed around your university experience.",
        groups: [
            {
                title: "Student Support",
                links: [
                    { title: "FAQ", url: "/faqs" },
                    { title: "Scholarship", url: "/scholarship" },
                    { title: "Anti-Ragging Policy", url: "/anti-ragging-policy" },
                    { title: "Download", url: "/download-form" },
                    { title: "Alumni Portal", url: "https://isbmalumni.com/" },
                    { title: "Voter Portal", url: "https://voterportal.eci.gov.in/" },
                    { title: "Anti Ragging Committee", url: "/anti-ragging-committee" },
                    { title: "Anti-Ragging Squad", url: "/anti-ragging-squad" },
                ],
            },
            {
                title: "Committees & Student Life",
                links: [
                    { title: "Scheduled Caste and Scheduled Tribe Committee", url: "/sc-and-st-committee" },
                    { title: "Other Backward Class Committee", url: "/obc-committee" },
                    { title: "Student's Grievance Redressal Committee", url: "/student-grievance-committee" },
                    { title: "Internal Complaints Committee", url: "/icc-committee" },
                    { title: "Cultural Committee", url: "/cultural-committee" },
                    { title: "Student Council", url: "/student-council" },
                    { title: "Student ERP", url: "https://isbmuniversity.online/" },
                    { title: "Student Grievance", url: "/student-grievance" },
                ],
            },
        ],
        image: menu5,
    },

    Placements: {
        eyebrow: "Careers without limits",
        title: "Turn knowledge into professional momentum.",
        description:
            "Career preparation, industry exposure and employer connections from day one.",
        groups: [
            {
                title: "Career Development",
                links: [
                    { title: "About Placements", url: "/about-placements" },
                    { title: "Career Counselling", url: "/career-counselling" },
                    { title: "Global Readiness", url: "/global-readiness" },
                    { title: "Recruiters", url: "/recruiters" },
                    { title: "Campus Recruitment and Interview Training", url: "/campus-recruitment-interview-training" },
                    { title: "Work at ISBM University", url: "/work-at-isbmu" },
                ],
            },
        ],
        image: menu6,
    },

    Campus: {
        eyebrow: "Life at ISBMU",
        title: "A vibrant campus made for discovery.",
        description:
            "Modern learning spaces, rich student life and a community that feels like home.",
        groups: [
            {
                title: "Campus Facilities",
                links: [
                    { title: "Campus Infrastructure", url: "/campus-infrastructure", target: "_blank" },
                    { title: "Library", url: "/library", target: "_blank" },
                    { title: "Laboratory", url: "/laboratory", target: "_blank" },
                    { title: "Sports Facilities", url: "/sports-facilities", target: "_blank" },
                ],
            },
            {
                title: "Campus Experience",
                links: [
                    { title: "Extra Curricular", url: "/extra-curricular", target: "_blank" },
                    { title: "Digitized Learning System", url: "/digitized-learning-system" },
                    { title: "Bus Transportation", url: "/bus-transportation", target: "_blank" },
                    { title: "Hostel", url: "/hostel", target: "_blank" },
                ],
            },
        ],
        image: menu7,
    },

    International: {
        eyebrow: "Think globally",
        title: "A world of opportunity, within reach.",
        description:
            "Global partnerships and cross-cultural experiences that broaden every perspective.",
        groups: [
            {
                title: "Global Partnerships",
                links: [
                    { title: "International Partnerships", url: "/international-partnerships" },

                ],
            },
            {
                title: "International Students",
                links: [
                    { title: "International Students", url: "/international-students", target: "_blank" },
                ],
            },
        ],
        image: menu8,
    },
};

export default menuData;